import { clsx } from 'clsx';

import {
  borderRadiusHelpers,
  BorderRadiusProps
} from './border-radius/border-radius';
import { boxShadowHelpers, BoxShadowProps } from './box-shadow/box-shadow';
import { colorHelpers, ColorProps } from './color/color';
import { spacingHelpers, SpacingProps } from './spacing/spacing';
import { typographyHelpers, TypographyProps } from './typography/typography';

export interface ClassNames {
  // Additional classes to be passed into the component
  className?: string;
}

export type HelperProps = SpacingProps &
  BorderRadiusProps &
  BoxShadowProps &
  ColorProps &
  TypographyProps &
  ClassNames;

/* eslint-disable @typescript-eslint/no-explicit-any */
const createBaseDesignProps =
  (...fns: any[]) =>
  (args: any) =>
    fns.reduce((arg, fn) => fn(arg), args);
/* eslint-enable @typescript-eslint/no-explicit-any */

export const helpers = {
  defaultProps: {
    ...borderRadiusHelpers.defaultProps,
    ...spacingHelpers.defaultProps,
    ...boxShadowHelpers.defaultProps,
    ...colorHelpers.defaultProps,
    ...typographyHelpers.defaultProps,
    className: undefined
  },
  classnames: (props: HelperProps): string => {
    return clsx(
      spacingHelpers.classnames(props),
      borderRadiusHelpers.classnames(props),
      boxShadowHelpers.classnames(props),
      colorHelpers.classnames(props),
      typographyHelpers.classnames(props),
      props?.className
    );
  },
  // Props passed into base is HelperProps & all remaining props ([x: string]: any), essentially making it any.
  /* eslint-disable-next-line */
  base: (props: any) =>
    createBaseDesignProps(
      spacingHelpers.base,
      borderRadiusHelpers.base,
      boxShadowHelpers.base,
      colorHelpers.base,
      typographyHelpers.base
    )(props)
};
